import { useParams } from "react-router";
import { LeadDetail } from "@/components/leads/LeadDetail";

export const meta = () => [
  { title: "Lead | Ani Tech" },
  { name: "description", content: "Lead record — overview, tasks, artefacts" },
];

export default function LeadRoute() {
  const params = useParams<{ id?: string }>();
  return <LeadDetail faClientId={params.id ?? ""} />;
}

/** Named export consumed by OS-mode window registry. */
export function LeadDetailRoute({ faClientId }: { faClientId: string }) {
  return <LeadDetail faClientId={faClientId} />;
}
